import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute, { AdminRoute } from './components/common/ProtectedRoute';
import AppLayout from './components/common/AppLayout';
import LoginPage from './pages/LoginPage';
import AnnotationPage from './pages/AnnotationPage';
import AdminPage from './pages/AdminPage';
import RankingsPage from './pages/RankingsPage';
import NotFoundPage from './pages/NotFoundPage';
import ManualPage from './pages/ManualPage'; // Import the new ManualPage

// Basic MUI theme (can be customized)
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Example blue
    },
    secondary: {
      main: '#9c27b0', // Example purple
    },
  },
});

// Component to handle root redirection based on auth state
function RootRedirect() {
    const { isLoggedIn } = useAuth();
    // If logged in, default to Annotation page, otherwise to Login page
    return <Navigate to={isLoggedIn ? "/" : "/login"} replace />;
}


function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Normalize CSS */}
      <AuthProvider>
         <Router>
            <Routes>
                {/* Routes with the AppLayout (Header, Footer) */}
                <Route element={<AppLayout />}>
                    {/* Protected Routes (require login) */}
                    <Route element={<ProtectedRoute />}>
                        <Route path="/" element={<AnnotationPage />} />
                <Route path="/rankings" element={<RankingsPage />} />
                <Route path="/manual" element={<ManualPage />} />
                        {/* Admin Routes (require login + admin role) */}
                        <Route path="/admin" element={<AdminRoute />}>
                            <Route index element={<AdminPage />} />
                             {/* Add more admin sub-routes here if needed */}
                            {/* <Route path="users" element={<AdminUsersPage />} /> */}
                        </Route>
                    </Route>

                     {/* Public Routes */}
                      {/* Add other public pages here if needed */}

                 </Route>

                 {/* Routes without AppLayout */}
                 <Route path="/login" element={<LoginPage />} />


                 {/* Fallback 404 Route */}
                 <Route path="*" element={<NotFoundPage />} />

                 {/* Optional: Redirect from exact root path based on login */}
                 {/* <Route path="/" element={<RootRedirect />} /> */}

            </Routes>
         </Router>
      </AuthProvider>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </ThemeProvider>
  );
}

export default App;
